export default "__VITE_ASSET__CzItSg4D__"